export default __webpack_public_path__ + "static/media/wisetack-logo.1c570bdc.svg";